import Link from 'next/link';
import React from 'react';

import { ButtonControl, ButtonControlPropsInterface } from './button-control';

export type ButtonPropsInterface = ButtonControlPropsInterface & {
    nativeLink?: boolean;
    disableResponsive?: boolean;
    target?: string;
    rel?: string;
};

export const Button: React.FC<ButtonPropsInterface> = ({
    href,
    nativeLink = false,
    children,
    variant = 'default',
    appearance,
    size = 'medium',
    variation = 'filled',
    loading,
    form,
    disabled,
    icon,
    iconPosition = 'right',
    iconGap = 'medium',
    compactIconSpacing,
    id,
    onClick,
    block,
    type = 'submit',
    gradient = false,
    shadow = false,
    hideLabelUnder,
    hideLabelOver,
    disableResponsive,
    as,
    target,
    rel,
}) => {
    const ButtonStyled = (
        <ButtonControl
            variant={variant}
            appearance={appearance}
            size={size}
            loading={loading}
            disabled={disabled}
            id={id}
            icon={icon}
            iconPosition={iconPosition}
            iconGap={iconGap}
            compactIconSpacing={compactIconSpacing}
            onClick={onClick}
            block={block}
            form={form}
            variation={variation}
            type={type}
            gradient={variant === 'primary' ? true : gradient}
            shadow={variant === 'primary' ? true : shadow}
            hideLabelUnder={hideLabelUnder}
            hideLabelOver={hideLabelOver}
            disableResponsive={disableResponsive}
            as={as}
        >
            {children}
        </ButtonControl>
    );

    if (!href) {
        return ButtonStyled;
    }

    if (nativeLink) {
        return (
            <a href={href} target={target} rel={rel}>
                {ButtonStyled}
            </a>
        );
    }

    return (
        <Link href={href} passHref>
            <a target={target} rel={rel}>
                {ButtonStyled}
            </a>
        </Link>
    );
};
